import store from '@shared/store/index';
import DROPDOWN_NAMES from '@shared/constants/dropdowns/dropdownsName';

const POPUP_NAME = DROPDOWN_NAMES.contentPage;

export function closeContentPopup(){
  store.dispatch('Dropdowns/removeTheDropdown', POPUP_NAME);
}
